import React from 'react';
import PropTypes from 'prop-types';
import { Breadcrumb } from 'antd';

import useNavigation from "hooks/useNavigation";

import styles from './../styles';

const AdminBreadcrumbs = ({title, secondLevelTitle, secondLevelTitleLink}) => {

    const [activeNavItem, { getAdminMenu }] = useNavigation();

    const generateBreadcrumbLinks = () => {
        let breadcrumbItems = [
            {
                title: 'Admin',
                menu: { items: getAdminMenu({}) },
                dropdownProps: { trigger: ['click'] }
            },
            {
                title: title
            }
        ]

        if (secondLevelTitle) {
            const secondLevel = {
                title: <a href={secondLevelTitleLink}>{secondLevelTitle}</a>,
            }
            breadcrumbItems = breadcrumbItems.toSpliced(1, 0, secondLevel);
        }

        return breadcrumbItems;
    }

    return (
        <Breadcrumb
            style={styles.breadcrumb}
            items={generateBreadcrumbLinks()}
        />
    )
}

AdminBreadcrumbs.defaultProps = {
    secondLevelTitle: null,
    secondLevelTitleLink: "/admin"
}

AdminBreadcrumbs.propTypes = {
    title: PropTypes.string.isRequired,
    secondLevelTitle: PropTypes.string,
    secondLevelTitleLink: PropTypes.string
}

export default AdminBreadcrumbs;